/** Import core services */
import { CoreModule } from '@core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

/** APM tracking for Central Logn */
import { ApmModule, ApmService, ApmErrorHandler } from '@elastic/apm-rum-angular';

/** Bootstrap functionality include */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/** Add Routing */
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { LoadingComponent } from './loading/loading.component';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent, LoadingComponent],
  imports: [CoreModule, BrowserModule, AppRoutingModule, CommonModule, HttpClientModule, NgbModule, ApmModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(service: ApmService) {
    let apmEnvironment = 'prod';
    if (environment.baseDomain.includes('-dev')) {
      apmEnvironment = 'dev';
    } else if (environment.baseDomain.includes('-qa')) {
      apmEnvironment = 'qa';
    } else if (environment.baseDomain.includes('-sat')) {
      apmEnvironment = 'sat';
    } else if (environment.baseDomain.includes('-uat')) {
      apmEnvironment = 'uat';
    } else if (environment.baseDomain.includes('-preprod')) {
      apmEnvironment = 'preprod';
    }
    // Assign the proper environment value.
    environment.envName = apmEnvironment;
    // Agent API is exposed through this apm instance
    const apm = service.init({
      serviceName: 'ins-multi-family-widget-app',
      serverUrl: 'https://rp-central-log.apm.us-east-2.aws.elastic-cloud.com',
      environment: environment.envName,
      serviceVersion: '0.0.1',
      transactionSampleRate: 1.0,
    });
  }
}
